import { Cookie, UserStatus } from '@vue-util/cookie';

export class PdpUserStatus extends UserStatus {
  static is365Customer() {
    return Cookie.get('Login365Customer', 'MISCGCs') === 'Y';
  }

  static loyaltyCustomerSignInValidation() {
    return this.is365Customer() || super.isSignedIn() || super.isSoftSignedIn();
  }
}

export default PdpUserStatus;
